import type { Category } from "./Category.js";
import { Locale } from "./Locale.js";
import { namesOfProductCategoriesForMenu } from "./namesOfProductCategoriesForMenu.js";

export const namesOfRequiredCategories = {
	...namesOfProductCategoriesForMenu,
	fillings: { [Locale.cs]: "Náplně dortů" },
} as const;

export type RequiredCategories = Record<keyof typeof namesOfRequiredCategories, Category>;
